/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecentlySoldInventoryDTOFromJSON, RecentlySoldInventoryDTOToJSON, } from './RecentlySoldInventoryDTO';
/**
 * Check if a given object implements the InventoryDeletePreviewDTO interface.
 */
export function instanceOfInventoryDeletePreviewDTO(value) {
    return true;
}
export function InventoryDeletePreviewDTOFromJSON(json) {
    return InventoryDeletePreviewDTOFromJSONTyped(json, false);
}
export function InventoryDeletePreviewDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'recentlySoldCount': json['recentlySoldCount'] == null ? undefined : json['recentlySoldCount'],
        'windowDays': json['windowDays'] == null ? undefined : json['windowDays'],
        'listLimit': json['listLimit'] == null ? undefined : json['listLimit'],
        'recentlySold': json['recentlySold'] == null ? undefined : (json['recentlySold'].map(RecentlySoldInventoryDTOFromJSON)),
    };
}
export function InventoryDeletePreviewDTOToJSON(json) {
    return InventoryDeletePreviewDTOToJSONTyped(json, false);
}
export function InventoryDeletePreviewDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalCount': value['totalCount'],
        'recentlySoldCount': value['recentlySoldCount'],
        'windowDays': value['windowDays'],
        'listLimit': value['listLimit'],
        'recentlySold': value['recentlySold'] == null ? undefined : (value['recentlySold'].map(RecentlySoldInventoryDTOToJSON)),
    };
}
